import searchFiltersStore from '../store/searchFilters';
export default {
    install(Vue) {
        if (!Vue.$store.state['SearchFilters']) {
            Vue.$store.registerModule('SearchFilters', searchFiltersStore);
        }

        Vue.$router.beforeEach((to, from, next) => {
            if (!Vue.$store.state.SearchFilters.loaded) {
                Vue.$store.dispatch('SearchFilters/loadFilters').then(() => {
                    Vue.$search.initRoute(to, from, next);
                });
            } else {
                Vue.$search.initRoute(to, from, next);
            }
        });
    },
};
